import axios from 'axios'
/**
 * 自定义Axios实例
 */
const service = axios.create({
    timeout: 60000,
    withCredentials: true
})

// 添加请求拦截器
service.interceptors.request.use(
    (config) => {
        // 在发送请求之前做些什么
        config.headers['Authorization'] = JSON.parse(localStorage.getItem('headers')).token || 'Bearer 19b011be-b61a-4fd8-86e3-558ddbbd1edf'
        config.headers['Tenant-Id'] = JSON.parse(localStorage.getItem('headers')).TenantId || '418'
        config.headers['User-Type'] = JSON.parse(localStorage.getItem('headers')).UserType || '2'
        config.headers['User-Tenant-User-Type-Id'] = JSON.parse(localStorage.getItem('headers')).UserTenantUserTypeId || '2474'
        config.headers['Device'] = 'ANDROID'
        return config
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
service.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么
        return response.data
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 定义对外Get、Post、File请求
export default {
    get(url, param = {}, headers = {}) {
        return service.get(url, {
            params: param,
            headers: {
                ...headers
            }
        })
    },
    post(url, param = null, headers = {}) {
        return service.post(url, param, {
            headers
        })
    },
    put(url, param = null, headers = {}) {
        return service.put(url, param, {
            headers
        })
    },
    file(url, param = null, headers = {}) {
        return service.post(url, param, {
            headers: Object.assign(
                {
                    'Content-Type': 'multipart/form-data'
                },
                headers
            )
        })
    },
    delete(url, param = null, headers = {}) {
        return service.delete(url, {
            params: param,
            headers: Object.assign(
                {
                    'Content-Type': 'multipart/form-data'
                },
                headers
            )
        })
    }
}